"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGraphQlError = exports.getErrorType = exports.getErrorIcon = exports.getErrorTitle = void 0;
var lodash_1 = require("lodash");
var sprintf_js_1 = require("sprintf-js");
var errors = {
  PasswordStrengthError: 'Password is too weak. Please use a password which uses a mix of symbols and characters, and try again'
};
var ERROR_TITLES = {
  ACCESS_DENIED: 'Access Denied',
  SESSION_EXPIRED: 'Session Expired',
  GENERAL: 'Error'
};
var getName = function (err) {
  var matches = err.match(/GraphQL error:\s([a-z]+)/i);
  if (matches && matches.length > 1) {
    return matches[1];
  }
  return err;
};
var getErrorTitle = function (err, context) {
  var t = context.t;
  var type = (0, exports.getErrorType)(err, context);
  return t(ERROR_TITLES[type]);
};
exports.getErrorTitle = getErrorTitle;
var getErrorIcon = function (err, context) {
  var t = context.t,
    entities = context.entities,
    icons = context.icons;
  var type = (0, exports.getErrorType)(err, context);
  if (type === 'ACCESS_DENIED') {
    return icons.BanCircle;
  }
  if (type === 'SESSION_EXPIRED') {
    return icons.Entities.Unit;
  }
  return icons.ExclamationCircle;
};
exports.getErrorIcon = getErrorIcon;
var getErrorType = function (err, context) {
  if (err.match(/GraphQL error\: Unauthorised\./) || err.match(/Unauthorised\./)) {
    return 'ACCESS_DENIED';
  }
  return 'GENERAL';
};
exports.getErrorType = getErrorType;
var getGraphQlError = function (err, context) {
  var t = context.t,
    entities = context.entities,
    _a = context.action,
    action = _a === void 0 ? 'read' : _a,
    definition = context.definition;
  if ((0, lodash_1.startsWith)(err, "GraphQL error: Cannot return null for non-nullable field")) {
    return 'Sorry a database error occurred.<br><br>We have been notified of this issue.';
  }
  if ((0, lodash_1.startsWith)(err, "Network error: Error writing result to store for query")) {
    return 'Sorry a query error occurred.';
  }
  if ((0, lodash_1.startsWith)(err, "GraphQL error: Unauthorised")) {
    return t('Sorry, you don\'t currently have permission to view this item. This can mean that your session has expired, please try to refresh the page to renew your session.');
  }
  var userExistsMatches = err.match(/GraphQL error: The member account already exists./);
  if (userExistsMatches && userExistsMatches.length) {
    return t('This email is already in use by another account. Please use a different address and try again.');
  }
  var updateMatches = err.match(/GraphQL error\: Unauthorised\. You do not have permission to update this '([a-zA-Z]+)' record\./i);
  if (updateMatches && updateMatches.length) {
    var defn = definition || entities[updateMatches[1]];
    return t((0, sprintf_js_1.sprintf)('Sorry you <b>do not have the correct permissions</b> to update this %s.', defn ? defn.label : 'Entity'));
  }
  var badRequestMatches = err.match(/Network error: Response not successful: Received status code 400/i);
  if (badRequestMatches && badRequestMatches.length) {
    var defn = definition || entities[badRequestMatches[1]];
    if (action === 'update') {
      return t((0, sprintf_js_1.sprintf)('Sorry, we <b>cannot load this %s for editing</b> due to a server error.<br><br>We have been notified of this issue.', defn ? defn.label : 'Entity'));
    }
    return t((0, sprintf_js_1.sprintf)('<b>Sorry a server error occurred.</b>', defn ? defn.label : 'Entity'));
  }
  var readMatches = err.match(/GraphQL error\: Unauthorised\. You do not have permission to read this '([a-zA-Z]+)' record\./i);
  if (readMatches && readMatches.length) {
    var defn = definition || entities[readMatches[1]];
    if (action === 'update') {
      return t((0, sprintf_js_1.sprintf)('Sorry you <b>do not have the correct permissions</b> to edit this %s.', defn ? defn.label : 'Entity'));
    }
    return t((0, sprintf_js_1.sprintf)('Sorry you <b>do not have the correct permissions</b> to view this %s.', defn ? defn.label : 'Entity'));
  }
  var unauthMatches = err.match(/Unauthorised\./i);
  if (unauthMatches && unauthMatches.length) {
    return t('Sorry, you don\'t currently have permission to access this. This can mean that your session has expired, please try to refresh the page to renew your session.');
  }
  // TODO - add additional friendly error messages
  return errors[getName(err)] || err;
};
exports.getGraphQlError = getGraphQlError;